
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const storeskuApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listStoreSKUs: builder.query ({
      query: (params) => `v2/storesku/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["StoreSKU"]
    }),
    getStoreSKU: builder.query ({
      query: (storesku_id) => `v2/storesku/${storesku_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["StoreSKU"]
    }),

    updateStoreSKU: builder.mutation ({
      query: ({storesku_id, data}) => ({
        url: `v2/storesku/${storesku_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["StoreSKU"]
    }),
    deleteStoreSKU: builder.mutation ({
      query: (storesku_id) => ({
        url: `v2/storesku/${storesku_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["StoreSKU"]
    }),
    createStoreSKU: builder.mutation ({
      query: (data) => ({
        url: `v2/storesku/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["StoreSKU"]
    }),
  })
})


export const {
  useListStoreSKUsQuery,
  useLazyListStoreSKUsQuery,
  useGetStoreSKUQuery,
  useLazyGetStoreSKUQuery,

  useUpdateStoreSKUMutation,
  useDeleteStoreSKUMutation,
  useCreateStoreSKUMutation
} = storeskuApi
